module.exports = __webpack_public_path__ + "img/umbrella.30e6ba54.jpeg";